import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { QUERY } from "../../utilities/network";
import DashboardJourneyLevelChart from "../../components/dashboardJourneyLevelChart";
import LeadershipFeedback from "../../components/leadershipFeedback";
import DashboardPracticedAreaChart from "../../components/dashboardPracticedAreaChart";
import DashboardTrendChart from "../../components/dashboardTrendChart";
import PremiumSignup from "../../components/premiumSignup";
import Loader from "../../atoms/loader";
import { DashboardTitle } from "../../utilities/styles";
import DashboardStats from "../../components/dashboardStats";
import TopBehaviours from "../../components/topBehaviours";
import { GET_STATS } from "../../constants/requests";

const BasicDashboard = () => {
  const [statistics, setStatistics] = useState();
  const [admin, setAdmin] = useState();

  // Billa is fixing the new api call so it takes a bearer token that's received on login instead of the current headers
  // He's also adding the group_id's to another call so I don't need to send them
  // once that is fixed I can finish integrating the request

  useEffect(() => {
    const getStats = async () => {
      const data = await QUERY(GET_STATS);
      setStatistics(data.statistics);
      setAdmin(data.admin);
    };
    getStats();
  }, []);

  if (!statistics || !admin) {
    return <Loader />;
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <DashboardTitle>
          Welcome to the {admin.organization.name} Leadership Dashboard!
        </DashboardTitle>
      </Grid>
      <DashboardStats statistics={statistics} />
      <Grid item xs={6}>
        <DashboardJourneyLevelChart journey_sessions={statistics.journey_sessions} />
      </Grid>
      <Grid item xs={6}>
        <TopBehaviours loops={statistics.practiced_loops} />
      </Grid>
      <Grid item xs={12}>
        <DashboardPracticedAreaChart
          practicedAreas={statistics.practiced_areas}
          practicedLoops={statistics.practiced_loops}
        />
      </Grid>
      <Grid item xs={6}>
        <LeadershipFeedback effect_survey={statistics.effect_survey} />
      </Grid>
      <Grid item xs={6}>
        <DashboardTrendChart weekly_trend={statistics.weekly_trend} />
      </Grid>
      <Grid item xs={12}>
        <PremiumSignup />
      </Grid>
    </Grid>
  );
};

export default BasicDashboard;
